import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

const TOKEN_EXPIRE_TIME = 30 * 60 * 1000;
let _urlCache = {};
class FileDeliveryService {
    static getFileContentType = (fileId, urlType) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.FileDelivery}${urlType}/${platformId}/${fileId}?h=true`,
            method: 'GET',
            parseJSON: false,
        });
    };

    static getContent = (contentId, extraHeaders, cacheParams, headersOnly, source) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        // Container or online
        // TODO: Check headers only parsing in apps is correct
        let s = process.env.REACT_APP_IS_CONTAINER === 'true' ? 'a' : 'o';
        if (source !== undefined) {
            s = source;
        }

        return fetchAPI(
            {
                token: token,
                url: `${config.FileDelivery}get-content/${platformId}/${contentId !== undefined ? contentId : ''}?s=${s}${
                    headersOnly !== undefined ? `&h=${headersOnly}` : ''
                }`,
                method: 'GET',
                aux: contentId,
                body: undefined,
                parseJSON: headersOnly === true ? false : true,
            },
            extraHeaders,
            cacheParams
        );
    };

    static getFile = (fileId, headersOnly) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();
        // Container or online
        // TODO: Check headers only parsing in apps is correct
        let s = process.env.REACT_APP_IS_CONTAINER === 'true' ? 'a' : 'o';
        return fetchAPI({
            token: token,
            url: `${config.FileDelivery}get/${platformId}/${fileId}?s=${s}${headersOnly !== undefined ? `&h=${headersOnly}` : ''}`,
            method: 'GET',
            parseJSON: headersOnly === true ? false : true,
        });
    };

    static getFileURL = (fileId, urlModifier, source) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        // Container or online
        let s = process.env.REACT_APP_IS_CONTAINER === 'true' ? 'a' : 'o';
        if (source !== undefined) {
            s = source;
        }
        let urlType = 'get';
        if (urlModifier) {
            urlType = urlModifier;
        }
        if (_urlCache[fileId] === undefined) {
            _urlCache[fileId] = {
                url: config.FileDelivery + urlType + '/' + platformId + '/' + fileId + '?k=' + token + '&s=' + s,
                date: new Date(),
            };
        } else if (new Date() - _urlCache[fileId].date >= TOKEN_EXPIRE_TIME) {
            _urlCache[fileId] = {
                url: config.FileDelivery + urlType + '/' + platformId + '/' + fileId + '?k=' + token + '&s=' + s,
                date: new Date(),
            };
        }
        return _urlCache[fileId].url;
    };
}

export default FileDeliveryService;
